import { useEffect } from "react";

const DEFAULT_TITLE = "Monaco Bar";
const DEFAULT_DESCRIPTION = "Diskretion, Eleganz und unvergessliche Momente.";
const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1614535428216-41a2e395ef88?w=1200";
const SITE_URL = "https://monaco-bar.at";

const SEOHead = ({ 
  title, 
  description, 
  image, 
  type = "website",
  url,
  noindex = false 
}) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | Monaco Bar` : DEFAULT_TITLE;
    const metaDescription = description || DEFAULT_DESCRIPTION;
    const metaImage = image || DEFAULT_IMAGE;
    const pageUrl = url ? `${SITE_URL}${url}` : SITE_URL;

    // Set document title
    document.title = fullTitle;

    // Helper to set/create meta tags
    const setMetaTag = (property, content, isOg = false) => {
      const selector = isOg ? `meta[property="${property}"]` : `meta[name="${property}"]`;
      let tag = document.querySelector(selector);
      
      if (!tag) {
        tag = document.createElement("meta");
        if (isOg) {
          tag.setAttribute("property", property);
        } else {
          tag.setAttribute("name", property);
        }
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    // Standard meta tags
    setMetaTag("description", metaDescription);
    if (noindex) {
      setMetaTag("robots", "noindex, nofollow");
    }

    // Open Graph tags
    setMetaTag("og:title", fullTitle, true);
    setMetaTag("og:description", metaDescription, true);
    setMetaTag("og:image", metaImage, true);
    setMetaTag("og:url", pageUrl, true);
    setMetaTag("og:type", type, true);
    setMetaTag("og:site_name", "Monaco Bar", true);

    // Twitter Card tags
    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag("twitter:title", fullTitle);
    setMetaTag("twitter:description", metaDescription);
    setMetaTag("twitter:image", metaImage);

    // Cleanup on unmount (reset to defaults)
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title, description, image, type, url, noindex]);

  return null; // This component doesn't render anything
};

export default SEOHead;
